import styled, { css, keyframes } from 'styled-components';

export const fadeIn = keyframes`
  from {
    opacity: 0
  }
  to {
    opacity: 1
  }
`;

export const fadeOut = keyframes`
  from {
    opacity: 1
  }
  to {
    opacity: 0
  }
`;

export const generateFadeEffet = (start, end) => keyframes`
  from {
    opacity: ${start}
  }
  to {
    opacity: ${end}
  }
`;

export const verticalSlideGenerator = (from, to) => keyframes`
  from {
    transform: translateY(${from});
  }
  to {
    transform: translateY(${to});
  }
`;

export const horizontalSlideGenerator = (from, to) => keyframes`
  from {
    transform: translateX(${from});
  }
  to {
    transform: translateX(${to});
  }
`;

export const generateBackroundColorEffect = (start, end) => keyframes`
  from {
    background: ${start}
  }
  to {
    background: ${end}
  }
`;

export const genAniSelector = (showAni, hideAni, duration, hideDuration) => (props) => {
  if (props.show)
    return css`
      animation-duration: ${duration}ms;
      animation-fill-mode: forwards;
      animation-name: ${showAni};
    `;
  else
    return css`
      animation-duration: ${hideDuration || duration}ms;
      animation-fill-mode: forwards;
      animation-name: ${hideAni};
    `;
};

export const wrapWithAnimation = (comp, { showAni, hideAni, duration }) => {
  return styled(comp)`
    ${genAniSelector(showAni, hideAni, duration)}
  `;
};
